import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id });
        // clear the fragment
        window.history.replaceState(null, "", "/account");
        await checkAuth();
        navigate("/account", { replace: true });
      } catch {
        navigate("/login?error=1", { replace: true });
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="pt-40 pb-40 text-center text-[#7A7A7A]" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
